module.exports = __webpack_public_path__ + "static/media/ss_1_jp.88b5d779.jpg";